module.exports = [{
      plugin: require('/Users/Shared/Data/work/Projects/FizzLanding/packages/landing-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
